class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = this.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => {
      if (input.form) allSearchForms.push(input.form);
    });

    if (this.input) {
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
    }

    if (allSearchForms.length < 2) return;

    allSearchForms.forEach((form) =>
      form.addEventListener('reset', this.onFormReset.bind(this))
    );

    this.allSearchInputs.forEach((input) =>
      input.addEventListener('input', this.onInput.bind(this))
    );
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);